var $6e4b63af77288b7a$exports = {};
$6e4b63af77288b7a$exports = {
    "pending": `\u{5F85}\u{5904}\u{7406}`
};


export {$6e4b63af77288b7a$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
